<template functional>
  <div>{{ props.item.charges.profit | toCurrency }}</div>
</template>

<script>
export default {
  name: "drayage-profit",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
